<template>
  <div class="sendPg">
   <img
        class="backs"
        @click="goHome"
        v-lazy="require('./../../../assets/img/back2.png')"
      />
    <van-tabs v-model="activeName" @click="getroadList">
      <van-tab title="兑换测评" name="a" class="tac">
        <div class="code">
          <img
            v-if="!exchangeFlag && !errBg"
            v-lazy="require('./../../../assets/img/test/bg_exchange.png')"
          />
          <img
            v-if="exchangeFlag && !errBg"
            v-lazy="require('./../../../assets/img/test/bg_exchange.png')"
          />
          <img
            v-if="errBg"
            v-lazy="require('./../../../assets/img/test/bg_exchange.png')"
            alt=""
          />
          <div
            class="mt-10 mt-my"
            style="
              padding-left: calc(15% + 15px);
              text-align: left;
              margin-top: 31px;
            "
          >
            请输入手机号或兑换码领取:
          </div>
          <br />
          <input
            v-model="code"
            :style="{ color: errBg ? '#750705' : '#417505' }"
          />
          <van-icon
            :name="[errBg ? 'fail' : 'success']"
            v-if="exchangeFlag || errBg"
            :style="{ backgroundColor: errBg ? '#750705' : '#417505' }"
            class="rightIcon"
          />
          <p
            class="gray f12 mt-10"
            style="margin-bottom: -20px"
            v-if="exchangeFlag"
          >
            兑换成功
          </p>
          <p class="gray f12 mt-10" style="margin-bottom: -20px" v-if="errBg">
            兑换码有误或者已被兑换
          </p>
        </div>
        <van-button @click="next()" v-if="!exchangeFlag" class="next"
          >兑换</van-button
        >
        <van-button @click="goTest()" v-if="exchangeFlag" class="next"
          >立即测评</van-button
        >
      </van-tab>
      <van-tab title="我收到的" name="in">
        <NoPic style="margin-top: 50%" v-if="!sendListLen['in']"></NoPic>
        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
          <van-list
            v-model="isUpLoading"
            :finished="upFinished"
            :immediate-check="false"
            :offset="10"
            finished-text="我是有底线的"
            @load="onLoadList"
          >
            <sendCard
              v-for="(item, index) in sendList['in']"
              :key="index"
              :item="item"
            ></sendCard>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab title="我赠予的" name="out">
        <NoPic style="margin-top: 50%" v-if="!sendListLen['out']"></NoPic>
        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
          <van-list
            v-model="isUpLoading"
            :finished="upFinished"
            :immediate-check="false"
            :offset="10"
            finished-text="我是有底线的"
            @load="onLoadList"
          >
            <sendCard
              v-for="(item, index) in sendList['out']"
              :key="index"
              :item="item"
              type="sendDetai"
            ></sendCard>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import sendCard from "@/components/sendCard";
import NoPic from "@/components/NoPic";
import { getMySend, exchange } from "@/http/api";
export default {
  name: "send",
  data() {
    return {
      exchangeFlag: false,
      testId: "",
      code: "",
      activeName: "a",
      sendList: {
        in: [],
        out: [],
      },
      sendListLen: {
        in: 0,
        out: 0,
      },
      // 分页
      total: 0,
      codeFlag: "",
      pageSize: 1000, // 每页条数
      pageIndex: 1, // 页码
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      errBg: false,
    };
  },
  created() {
    this.code = this.$route.path.split("send/")[1] || "";
    this.codeFlag = this.$route.path.split("send/")[1] || "";
    localStorage["first"] = ''
    // this.getroadList();
  },
  methods: {
    goHome() {
      this.$router.push("/my/center");
    },
    next() {
      if (!localStorage["site_current_token"]) {
        localStorage["code"] = this.code;
        this.$router.push("/login");
      }
      
      let params = {
        redeem_code: this.code,
      };
      exchange(params).then((res) => {
        console.log(res);
        // this.exchangeFlag = true;
        // this.testId = res.data.evaluation.id
        if (res.data.detail === "无效测评码") {
          // this.exchangeFlag = true;
          this.errBg = true;
          this.exchangeFlag = false;
        } else {
          this.exchangeFlag = true;
          this.errBg = false;
          this.testId = res.data.evaluation.id;
        }
      });
    },
    goTest() {
      if (this.codeFlag) {
        this.$router.push("./../../test/" + this.testId + "/introduction");
      } else {
        this.$router.push("./../test/" + this.testId + "/introduction");
      }
    },

    getroadList() {
      this.sendList[this.activeName] = [];
      if (this.activeName !== "a") {
        let params = {
          // page: this.pageIndex,
          page_size: this.pageSize,
          category: this.activeName,
        };
        // this.sendList={}
        getMySend(params)
          .then((res) => {
            console.log(res);
            if (res.data.objects) {
              this.total = res.data.count;
              this.sendList[this.activeName] = this.sendList[
                this.activeName
              ].concat(res.data.objects);
              this.sendListLen[this.activeName] =
                this.sendList[this.activeName].length;
              console.log(this.sendList[this.activeName]);
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isDownLoading = false;
            this.isUpLoading = false;
          });
      }
      console.log("获取列表", this.sendList);
    },
    // 下拉刷新
    onDownRefresh() {
      this.sendList[this.activeName] = [];
      this.pageIndex = 1;
      this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
      this.getroadList(); // 加载数据
    },
    // 上拉加载请求方法
    onLoadList() {
      if (this.total > this.pageIndex * this.pageSize) {
        this.pageIndex++;

        this.getroadList();
      } else {
        this.upFinished = true;
      }
    },
  },
  components: {
    sendCard,
    NoPic,
  },
};
</script>

<style lang="less">
.backs {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
  z-index:100;
}
.sendPg {
  .code {
    // margin-left: 10%;
    margin-top: 20%;

    mt-my {
      font-size: 18px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #030303;
      line-height: 27px;
    }

    img {
      width: 150px;
      height: 150px;
    }

    h1 {
      // font-size: larger;
      margin-left: -30%;
    }

    input {
      text-align: center;
      border-radius: 18px;
      line-height: 1rem;
      width: 60%;
      background-color: #eceff5;
      border: 1px solid #ededed;
    }
  }

  .next {
    width: 90%;
    text-align: center;
    line-height: 25px;
    margin-left: 5%;
    border-radius: 18px;
    margin-top: 20%;
    background-color: #42686e;
    color: white;
  }

  .rightIcon {
    width: 20px;
    height: 20px;
    // display: inline-block;
    background-color: green;
    border-radius: 10px;
    color: white;
    float: right;
    margin-top: 0.2rem;
    margin-left: -1.2rem;
    margin-right: 1.2rem;
  }

  .van-tab {
    background-color: #eceff5;
  }

  .van-tabs__line {
    background-color: #42686e;
    /*width: 100%;*/
  }
}
</style>
